'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { type Session } from 'next-auth';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Callout from '@classify/react-core-components/Callout';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import Hero from './Hero';
import EditionPanel from './EditionPanel';
import Overview from './Overview';
import TabBar from './TabBar';
import PathPromotion from './PathPromotion';
import Credits from './Credits';
import Footer from './Footer';
import Section from './Section';
import TableOfContent, { TocVariants } from './TableOfContent/TableOfContent';
import COURSE_TABS from '../_constants/courseTabs';
import { useCourseContext } from '../_contexts/CourseContext';
type Props = {
  referrer: string | null;
  introduction?: string;
  user?: Session['user'];
};
const LMS_REFERRERS = ['360learning'];
export default function Page(t0) {
  const $ = _c(42);
  const {
    user,
    referrer,
    introduction
  } = t0;
  const {
    canEditCourse,
    course,
    tableOfContent
  } = useCourseContext();
  const footerRef = useRef(null);
  let t1;
  if ($[0] !== referrer) {
    t1 = referrer && LMS_REFERRERS.find(lmsReferrer => referrer.includes(lmsReferrer));
    $[0] = referrer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isLmsReferrer = t1;
  const shouldDisplaySwitchAccountWarning = isLmsReferrer && user && !user.organization;
  if (!course) {
    return null;
  }
  const {
    isActive,
    isPreregistrable,
    authors,
    creatorPartners,
    license,
    updatedAt,
    isSinglePage
  } = course;
  let t2;
  if ($[2] !== shouldDisplaySwitchAccountWarning) {
    t2 = shouldDisplaySwitchAccountWarning && <ContentWrapper><Callout type="warning" sx={{
        marginY: 2
      }}><Typography variant="h5">{translate("course_home.coming_from_LMS.wrong_account.banner.title")}</Typography><Typography variant="body">{translate("course_home.coming_from_LMS.wrong_account.banner.desc")}</Typography></Callout></ContentWrapper>;
    $[2] = shouldDisplaySwitchAccountWarning;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = user?.id;
  let t4;
  if ($[4] !== t3) {
    t4 = <Hero userId={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== canEditCourse || $[7] !== course.id || $[8] !== course.publishedAt) {
    t5 = canEditCourse && <ContentWrapper><EditionPanel courseId={course.id.toString()} isPublished={Boolean(course.publishedAt)} variant={TocVariants.HOMEPAGE} /></ContentWrapper>;
    $[6] = canEditCourse;
    $[7] = course.id;
    $[8] = course.publishedAt;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isSinglePage || $[11] !== user?.id) {
    t6 = !isSinglePage && <TabBar userId={user?.id} footerRef={footerRef} />;
    $[10] = isSinglePage;
    $[11] = user?.id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== introduction) {
    t7 = <ContentWrapper><Section id={COURSE_TABS.TAB_OVERVIEW}><Overview introduction={introduction} /></Section></ContentWrapper>;
    $[13] = introduction;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isActive || $[16] !== isPreregistrable) {
    t8 = (isActive || isPreregistrable) && <PathPromotion />;
    $[15] = isActive;
    $[16] = isPreregistrable;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== course.categoryColor || $[19] !== isSinglePage || $[20] !== tableOfContent) {
    t9 = tableOfContent && !isSinglePage && <Section id={COURSE_TABS.TAB_TOC}><TableOfContent color={course.categoryColor} variant={TocVariants.HOMEPAGE} /></Section>;
    $[18] = course.categoryColor;
    $[19] = isSinglePage;
    $[20] = tableOfContent;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== authors || $[23] !== creatorPartners || $[24] !== license || $[25] !== updatedAt) {
    t10 = <Section id={COURSE_TABS.TAB_CREDITS}><Credits teachers={authors} creators={creatorPartners} license={license} updatedAt={updatedAt} /></Section>;
    $[22] = authors;
    $[23] = creatorPartners;
    $[24] = license;
    $[25] = updatedAt;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <ContentWrapper>{t9}{t10}</ContentWrapper>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      mb: 0
    };
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = user?.id;
  let t14;
  if ($[31] !== t13) {
    t14 = <Section ref={footerRef} sx={t12}><Footer userId={t13} /></Section>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t14 || $[35] !== t2 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
    t15 = <>{t2}{t4}{t5}{t6}{t7}{t8}{t11}{t14}</>;
    $[33] = t11;
    $[34] = t14;
    $[35] = t2;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}